import { createSelector } from 'reselect'

const interactiveVideoData = state => state.interactiveVideoCreation

const videoSavingStatusSelector = createSelector(
	[ interactiveVideoData ],
	interactiveVideo => interactiveVideo.status
)

export default videoSavingStatusSelector
